import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, notification } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import '../../assets/css/menu.css';
import ima from '../../../src/assets/images/logo_ies_bco.png';
import btn_registro from '../../../src/assets/images/2026/Logos-Botones/Boton_Registro_header.png';
import { Auth } from "../../utils/AuthContext";

const secciones = [
  { nombre: 'INICIO', nombre_en: 'HOME', url: '/' },
  { nombre: 'ACERCA DE', nombre_en: 'ABOUT US', url: '/#acerca-de' },
  { nombre: 'AGENDA', nombre_en: 'PROGRAM', url: '/#agenda' },
  { nombre: 'CONFERENCISTAS', nombre_en: 'SPEAKERS', url: '/#conferencistas' },
  { nombre: 'PATROCINADORES', nombre_en: 'SPONSORS', url: '/#patrocinadores' },
];

const mensaje = (tipo, titulo, texto = '') => {
  notification[tipo]({
    message: titulo,
    description: texto,
    duration: 5,
  });
};

const Header = ({ idioma, setIdioma, mostrar_login, setMostrarLogin }) => {
  const { usuario } = useContext(Auth);
  const [menuMovil, setMenuMovil] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const isES = idioma === 'es';

  const toggleMenu = () => setMenuMovil(prev => !prev);
  const cerrarMenu = () => setMenuMovil(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLoginRequired = () => {
    const msg = isES
      ? 'Por favor inicie sesión para acceder a este contenido.'
      : 'Please login to access this content';

    mensaje('warning', msg);
    setMostrarLogin(true);
    cerrarMenu();
  };

  const renderSecciones = () =>
    secciones.map((sec) => (
      <Link key={sec.url} className="titles" to={sec.url} onClick={cerrarMenu}>
        <span className="seccion">
          {isES ? sec.nombre : sec.nombre_en}
        </span>
      </Link>
    ));

  const renderAuth = (isMobile = false) => {
    if (usuario) {
      return (
        <Link
          className={`titles ${isMobile ? 'menu_mostrar_movil' : ''}`}
          to="/cerrar-sesion"
          onClick={cerrarMenu}
        >
          <span className="seccion">
            {isES ? 'Cerrar sesión' : 'Log out'}
          </span>
        </Link>
      );
    }

    return (
      <a
        className={` ${isMobile ? '' : ''}`}
        href="#registro"
      >
        <img src={btn_registro} width={'120px'} alt="registro" />
      </a>
    );
  };

  return (
    <Row
      justify="center"
      align="middle"
      className={scrollY > 80 ? "navbar--hidden" : "contenedor_header"}
    >
      {/* LOGO */}
      <Col xs={3} md={4} style={{ padding: '15px 20px', textAlign: 'left' }}>
        <img alt="logo" className="log_header" src={ima} />
      </Col>

      {/* MENU MOBILE ICON */}
      <Col xs={{ span: 4, offset: 13 }} md={0}>
        <MenuOutlined style={{ color: '#fff' }} onClick={toggleMenu} />
      </Col>

      {/* MENU DESKTOP */}
      <Col xs={0} md={14}>
        {renderSecciones()}
        {renderAuth()}
      </Col>

      {/* MENU MOBILE */}
      {menuMovil && (
        <Col xs={24} md={0}>
          {renderSecciones()}
          {renderAuth(true)}
        </Col>
      )}
    </Row>
  );
};

export default Header;